export default "__VITE_ASSET__lbZ49XJk__"